export default {
    theme: { light: 'Tema Claro', dark: 'Tema Oscuro' },
    login: {
      textCredenciais: 'Ingrese sus credenciales',
      acessLogin: 'Usuario',
      acessPassword: 'Contraseña',
      lembrarSenha: 'Recordar usuario y contraseña',
      forgotPass: 'Olvidé mi contraseña',
      Enter: 'Entrar',
      escolhaApelido: 'Elija su apodo',
      descApelido: 'Para continuar, defina un apodo de visualización.'
    },
    registro: {
    titleRegister: 'Registrar',
    labelUsuario: 'Usuario',
    ruleUsuarioRequired: 'Usuario es obligatorio',
    labelApelido: 'Apodo',
    ruleApelidoRequired: 'Apodo es obligatorio',
    labelEmail: 'Correo electrónico',
    ruleEmailRequired: 'Correo electrónico es obligatorio',
    ruleEmailInvalid: 'Correo electrónico inválido',
    labelSenha: 'Contraseña',
    ruleSenhaRequired: 'Contraseña es obligatoria',
    ruleSenhaMin: 'Mínimo 8 caracteres',
    ruleSenhaLetter: 'Use al menos una letra',
    ruleSenhaNumber: 'Use al menos un número',
    ruleSenhaSymbol: 'Use al menos un símbolo',
    strengthFraca: 'Débil',
    strengthMedia: 'Media',
    strengthForte: 'Fuerte',
    labelRepeatPassword: 'Repetir Contraseña',
    ruleConfirmationRequired: 'Confirmación es obligatoria',
    rulePasswordsMatch: 'Las contraseñas no coinciden',
    btnRegister: 'Registrar',
    alertSuccess: '¡Cuenta pendiente creada! Verifique su código de confirmación.'
  },
    download: {
    title: 'Descarga nuestro cliente ahora',
    btnDownload: 'Descargar'
  },
   characters: {
    title: 'Mis personajes',
    youHave: 'Tienes {count} personaje(s).',
    noCharacters: 'No tienes personajes.',
    classLabel: 'Clase:',
    levelLabel: 'Nivel:',
    goldLabel: 'Oro:',
    silverLabel: 'Plata:',
    bronzeLabel: 'Bronce:',
    createdLabel: 'Creación:',
    rebirthsLabel: 'Reencarnaciones:',
    bannedLabel: 'Prohibido:',
    yes: 'Sí',
    no: 'No'
  },
    menu: {
      home: 'Principal',
      login: 'Entrar',
      register: 'Registrar',
      download: 'Descarga',
      discord: 'Discord',
      info: 'Mis Datos',
      changePassword: 'Cambiar información',
      market: 'Céfiro Zephyr',
      inbox: 'Bandeja (en desarrollo)',
      coinsBr: 'Zephyr Coins Brasil',
      coinsInt: 'Zephyr Coins Internacional',
      wikia: 'Zephyr Wikia',
      ranked: 'Puntuación Clasificatoria',
      alquimia: 'Crear Alquimia',
      atts: 'Notas de Actualización',
      roulette: 'Ruleta de la Suerte',
      daily: 'Recolecta Diaria',
      loggedAs:'Iniciado sesión como',
      casino: 'Casino Zephyr (en desarrollo)',
      escala: 'Escala Zephyr',
      logout: 'Salir'
    },
    snackbar: { newMessages: '¡Has recibido {count} mensaje(s)!' },
    footer:   { copy: '{site} - Todos los derechos reservados' },
    hero: {
      title:    'Grand Fantasia Zephyr',
      subtitle: 'el mejor servidor privado de Grand Fantasia'
    },
    chat: { greeting: '¡Hola! Estamos ansiosos de tenerte, accede a nuestro discord!' },
  
    ranks: {
      title:        'DESTACADOS',
      currentMonth: 'Mes de: {month}',
      deaths:       'Top Muertes',
      crystalDamage:'Top Daño al Cristal',
      heal:         'Top Curación',
      playerDamage: 'Top Daño a Jugadores',
      wins:         'Top Victorias',
      noData:       '— sin datos'
    },
  
    changeCreds: {
      greeting1: 'Parece que no te sientes muy seguro jaja…',
      greeting2: 'Puedes cambiar tus credenciales',
      ninjaAlt:  'Ninja',
  
      newEmail: {
        label: 'Nuevo Correo (!)',
        hint:  'No estás obligado a cambiar el correo; hazlo si quieres.'
      },
      currentPassword: { label: 'Contraseña Actual' },
      newPassword:     { label: 'Nueva Contraseña' },
      confirmPassword: { label: 'Repetir Nueva Contraseña' },
  
      updateButton: 'Actualizar',
  
      emailConfirmModal: {
        title:        'Confirma tu correo',
        emailField:   { label: 'Ingresa tu correo actual' },
        cancelButton: 'Cancelar',
        confirmButton:'Confirmar'
      },
  
      validation: {
        emailInvalid: 'Formato de correo inválido',
        emailRequired:'Correo obligatorio'
      },
  
      error: {
        noChange:        'Solo puedes avanzar cambiando correo o contraseña.',
        fillPassword:    'Completa todos los campos de contraseña.',
        passwordMismatch:'Las nuevas contraseñas no coinciden.',
        passwordLength:  'La nueva contraseña debe tener al menos 8 caracteres.'
      },
  
      success: {
        updated: '¡Credenciales actualizadas con éxito!'
      }
    },
    inbox: {
        title:           'Bandeja ({count} pendientes)',
        loginRequired:   'Necesitas iniciar sesión para ver tus mensajes.',
        from:            'de {sender}',
        gold:            '{amount} Oro 🟨',
        silver:          '{amount} Plata ⚪',
        bronze:          '{amount} Bronce 🟤',
        item:            'Artículo: {name}'
      },
      wiki: {
        searchPlaceholder: 'Escribe para buscar un artículo…',
        loading:           'Cargando…',
        itemIconAlt:       'Icono del artículo {name}',
        setItemsTitle:     'Artículos del Conjunto',
        setBonusesTitle:   'Bonificaciones del Conjunto',
        recipeTitle:       'Receta de Fabricación',
        recipeQty:         'Cantidad: {qty}',
        obtainTitle:       'Cómo obtenerlo',
        closeButton:       'Cerrar'
      },
      rank: {
        selectGroupLabel: 'Seleccione Agrupación',
        none:             '— ninguno —',
        loading:          'Cargando...',
        position:         'Posición',
        name:             'Nombre',
        level:            'Nivel',
        class:            'Clase',
        rebirth:          'Reencarnación',
        reincarnated:     'Reencarnado',
        notReincarnated:  'No Reencarnado',
    
        ranks: {
          deaths:        'Rank de Muertes',
          crystalDamage: 'Rank de Daño Cristal',
          heal:          'Rank de Curación',
          playerDamage:  'Rank de Daño a Jugadores',
          wins:          'Rank de Victorias'
        },
    
        stat: {
          deaths:        'Muertes',
          crystalDamage: 'Daño Cristal',
          heal:          'Curación',
          playerDamage:  'Daño a Jugadores',
          wins:          'Victorias'
        }
      },
      alchemy: {
        title:           '¡Hola! Bienvenido, envía tu sugerencia de alquimia',
        alt:             'Imagen de alquimia',
        roundLabel:      'Ronda {n}:',
        itemPlaceholder: 'ID del artículo {n}',
        sendButton:      'Enviar sugerencia a Discord',
        loginError:      'Necesitas iniciar sesión.',
        successMessage:  '¡Sugerencia enviada con éxito!',
        sendError:       'Error al enviar la sugerencia.',
         inserirLote: 'Insertar en lote',
        idItem:      'Ingrese el ID del ítem',
        regras: {
        title: '¡Reglas!',
        forbiddenIntro: 'No está permitido:',
        forbiddenItems: 
          'consumibles de la isla piedras de la torre o del kaos equipo tarot y botines especiales de invasión, como núcleos de emisario equipos (set, arma, anillo y capa) de cualquier tipo artículos exclusivos de la alquimia-s top rw y artículos lanzados hace menos de 2 meses artículos NT en la última ronda',
        conclusion: 'Todas las alquimias serán evaluadas; si incumple las reglas, no serán validadas.'
      }
      },
    escala: {
      // Títulos principais
      title: 'Escala de premios',
      subtitle: 'Escala del mes de {currentMonthName} – plazo de cierre: {timeRemaining}',
      spent: 'Has gastado {spentPoints} puntos',
      chooseYourRescue: 'Elige tu recompensa',

      // Botão “extra eligible”
      btnExtraEligible: 'Tienes artículos de rango para canjear',

      // Tier card (os nomes “Bronce”, “Plata” etc. ficam no data original)
      redeemed: 'Canjeado',
      redeem: 'Canjear',

      // No card de pacote
      bundlePackage: 'Paquete de artículos:',
      noDescription: '[Sin descripción]',

      // Ranking
      topDonorsTitle: 'Nuestros 10 mejores donantes del mes',
      columnPlayer: 'Jugador',
      columnSpent: 'Gastado',

      // Prêmios extras
      extraRewardsTitle: 'Recompensas extra para nuestros mejores donantes',
      youAre: '¡Estás en {rank}º lugar!',
      availablePrizes: 'Premios disponibles:',
      availablePrize: 'Premio disponible:',
      clayX: 'Barro ×{quantity}',
      surpriseGMClick: 'Sorpresa GM (haz clic para elegir)',
      instruction: 'Los artículos anteriores son recompensas extras para nuestros mejores donantes. No dejes de participar.',

      // Botões genéricos
      cancel: 'Cancelar',
      redeemSurprise: 'Canjear Sorpresa',

      // Títulos de diálogos
      chooseYourSurprise: 'Sorpresa GM: elige tu artículo',
      chooseYourExtraSurprise: 'Sorpresa GM (Recompensa Extra): elige tu artículo',
      rescueExtraTitle: 'Canje de Recompensa Extra'
    },
     service: {
    title: 'Solicitar Servicio',
    selectServiceLabel: 'Seleccione el servicio',
    options: {
      changeCharacterName: 'Cambio de Nombre de Personaje',
      recoverItem: 'Recuperar Ítem',
      changeGuildName: 'Cambio de Nombre de la Gremio',
      recoverDeletedChar: 'Recuperar Personaje'
    },
    selectCharLabel: 'Seleccione el personaje',
    newCharacterNameLabel: 'Nuevo Nombre del Personaje',
    lostItemIdLabel: 'ID del Ítem Perdido',
    newGuildNameLabel: 'Nuevo Nombre del Gremio',
    deletedCharNameLabel: 'Nombre del Personaje Eliminado',
    buttonRequest: 'Solicitar',
    errors: {
      notAuthenticated: 'Usuario no autenticado.',
      selectCharAndName: 'Seleccione un personaje e ingrese el nuevo nombre.',
      informItemId: 'Ingrese el ID del ítem.',
      informNewGuildName: 'Ingrese el nuevo nombre del gremio.',
      informDeletedCharName: 'Ingrese el nombre del personaje eliminado.'
    },
    success: '¡Pedido enviado con éxito!'
  },
  zephyr: {
    title: 'Adquiera Zephyr Points (Compra realizada con moneda brasileña)',
    labelAmountReal: 'Valor en Reales',
    willReceive: 'Recibirás:',
    coins: 'Zephyr Coins',
    buttonBuy: 'Adquirir',
    errorPositive: 'Por favor, ingrese un valor mayor que cero.',
    errorPayment: 'No se pudo iniciar el pago. Inténtelo de nuevo.',
    docTitle: 'Grand Fantasia Zephyr'
  },
   acquire: {
    title: 'Compra de Puntos Zephyr (Compra realizada con moneda internacional)',
    labelValueReal: 'Valor en Reales',
    receive: 'Recibirás:',
    coins: 'Zephyr Coins',
    approxUSD: 'Aproximadamente {usd} USD',
    sendOrderButton: 'Enviar Pedido',
    alertValueGreaterZero: 'Por favor, ingrese un valor mayor que cero.',
    alertLogin: 'Por favor, inicie sesión para continuar.',
    alertSuccess: 'Pedido enviado! Recibirás {coins} Zephyr Coins (≈ {usd} USD).',
    alertError: 'No se pudo enviar el pedido. Inténtalo de nuevo.'
  },
  daily:{
    title:'Recompensa diaria',
    subtitle:'Reclama tu recompensa diaria hoy',
    rescue:'Rescate'
  },
  roulette: {
    headerTitle: 'Ruleta de la Suerte Zephyr',
    headerSubPoints: 'Precio de la ruleta: 500 Zephyr points',
    headerSubBonus: 'Precio de la ruleta: 1000 Zephyr bonus',
    user: 'Usuario',
    pointsLabel: 'Puntos',
    bonusLabel: 'Bono',
    title: 'Ruleta de la Suerte',
    spinButtonAlt: 'Girar',
    insufficientTitle: 'Saldo insuficiente',
    insufficientMessage: 'Necesitas {cost} Zephyr points para girar.',
    close: 'Cerrar',
    congratsTitle: '¡Felicidades!',
    congratsMessage:
      'Felicidades, ganaste {quantity}x {name}. Verifícalo en la tienda del juego y reclama tu premio.'
  }
  }
  